/* Neil Parker · Farewell bag builder. The panel IS the Shopify cart: every change goes
   through /cart/*.js, so the drawer, the header and any other page show the same bags.
   The free Secret Gift rides along with the first bag and leaves with the last one,
   the same rule the cart drawer enforces. The preview artifact swaps in window.JRF_ENV. */
(function () {
  "use strict";
  var root = document.querySelector("[data-jrf-builder]");
  if (!root || root.__jrf) return;
  root.__jrf = true;
  var D = JSON.parse(root.querySelector("[data-jrf-data]").textContent);
  var PAGE = 24;
  var TABS = [
    { key: "all", label: "All" }, { key: "best", label: "Bestsellers" },
    { key: "backpacks", label: "Backpacks" }, { key: "leather-backpacks", label: "Leather Backpacks" },
    { key: "messenger", label: "Messenger Bags" }, { key: "duffle", label: "Duffle Bags" }
  ];
  var HEX = {"green army":"#4b5a3c","waxed green army":"#4b5a3c","khaki":"#a89468","waxed khaki":"#a89468","coffee":"#5f3f2b","black":"#1f1e1c","brown":"#7b4b2a","dark grey":"#4d4f50","light grey":"#a9aaa6","grey":"#7d7e7b","army grey":"#5d6358","emerald":"#5e7f73","light green":"#8a9a6a","lake green":"#4f7a6e","waxed green":"#55613f","light blue":"#8fb0c8","blue":"#3d5a78","red":"#8f2f27","beige":"#d6c6a3","sand":"#cdb894","slate":"#5d6670","rose":"#c99d98","dark gray":"#4d4f50","light gray":"#a9aaa6","gray":"#7d7e7b","army gray":"#5d6358"};
  var hex = function (c) { return HEX[String(c || "").toLowerCase()] || "#999"; };
  var esc = function (s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", "\"": "&quot;" }[c]; }); };
  var tierOf = function (n) { return n >= 4 ? 30 : n === 3 ? 25 : n === 2 ? 20 : 0; };

  /* Format like the store does for this visitor's market: Liquid hands over 123456.78
     run through the money filter ("$123,456.78" in the US, "$123,456.78 CAD" in Canada). */
  var FMT = (function () {
    var s = String(D.sample || "").replace(/<[^>]*>/g, "");
    var m = s.match(/^(.*?)123(.?)45[67](?:(.)(78))?(.*)$/);
    if (!m) return { pre: "$", th: ",", dec: ".", decimals: true, post: "" };
    return { pre: m[1], th: m[2], dec: m[3] || ".", decimals: !!m[4], post: m[5] };
  })();
  function money(cents) {
    var v = (cents || 0) / 100, parts = v.toFixed(FMT.decimals ? 2 : 0).split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, FMT.th);
    return FMT.pre + parts[0] + (parts[1] ? FMT.dec + parts[1] : "") + FMT.post;
  }

  /* ---------- market split ----------
     Outside the US and Canada the store shows 10% off instead of the farewell prices. The theme's
     market script decides the visitor's side (window.FA_MARKET_VIEW, root class fa-mkt-intl) and
     anchors the struck price on whole pounds minus 5p; prices here are drawn by this script, so it
     applies the very same anchor itself instead of leaving them to the theme's selectors. */
  var intl = function () { return window.FA_MARKET_VIEW === "intl" || /(^|\s)fa-mkt-intl(\s|$)/.test(document.documentElement.className); };
  function cmpOf(price, compare) {
    if (!intl()) return compare > price ? compare : 0;
    var d = window.FA_MARKET && typeof window.FA_MARKET.disc === "number" ? window.FA_MARKET.disc : 0.1;
    if (!(price > 0) || !(d > 0) || d >= 1) return 0;
    var a = Math.round(Math.round(price / 100 / (1 - d) + 0.05) * 100 - 5);
    return a > price ? a : 0;
  }
  var savePct = function (price, cmp) { if (!(cmp > price)) return 0; return intl() ? Math.round((cmp - price) * 100 / cmp) : Math.round((1 - price / cmp) * 100 / 5) * 5; };

  /* ---------- products ---------- */
  var P = [], byId = {}, byVariant = {};
  D.products.forEach(function (p) {
    if (byId[p.id]) return; // a bag in two collections shows once
    var parts = String(p.t).split("|");
    p.type = parts[0].trim(); p.city = (parts[1] || parts[0]).trim();
    p.v = (p.v || []).filter(function (v) { return v && v.id; });
    if (!p.v.length) return;
    byId[p.id] = p; P.push(p);
    p.v.forEach(function (v) { byVariant[v.id] = { p: p, v: v }; });
  });
  var bestRank = {}; (D.best || []).forEach(function (id, i) { bestRank[id] = i; });
  var catRank = { backpacks: 0, "leather-backpacks": 1, messenger: 2, duffle: 3 };
  var order = P.map(function (p, i) { return { p: p, i: i }; });
  order.sort(function (a, b) {
    var ba = a.p.id in bestRank ? bestRank[a.p.id] : 1e6, bb = b.p.id in bestRank ? bestRank[b.p.id] : 1e6;
    return ba - bb || (catRank[a.p.c] - catRank[b.p.c]) || a.i - b.i;
  });
  P = order.map(function (o) { return o.p; });
  var BEST = P.filter(function (p) { return p.id in bestRank; });
  var tagged = {}; BEST.slice(0, 6).forEach(function (p) { tagged[p.id] = true; });

  /* ---------- cart adapter ---------- */
  function shopifyEnv() {
    var req = function (url, body) {
      return fetch(url, { method: body ? "POST" : "GET", credentials: "same-origin", cache: "no-store", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: body ? JSON.stringify(body) : undefined })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error((j && (j.description || j.message)) || "Something went wrong. Please try again."); return j; }); });
    };
    var strip = function (h) { var d = document.createElement("div"); d.innerHTML = h || ""; return (d.textContent || "").replace(/\s+/g, " ").trim(); };
    return {
      get: function () { return req("/cart.js"); },
      add: function (items) { return req("/cart/add.js", { items: items }).then(function () { return req("/cart.js"); }); },
      change: function (key, qty) { return req("/cart/change.js", { id: key, quantity: qty }); },
      announce: function (c) {
        document.dispatchEvent(new CustomEvent("cart:build"));
        document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart: c, source: "jrf" } }));
      },
      details: function (p) {
        return fetch(p.u.split("?")[0] + ".js", { credentials: "same-origin" }).then(function (r) { return r.json(); }).then(function (x) {
          var imgs = (x.images || []).slice(0, 10).map(function (s) { return s + (s.indexOf("?") > -1 ? "&" : "?") + "width=900"; });
          return { text: strip(x.description), imgs: imgs.length ? imgs : p.i };
        });
      }
    };
  }
  var ENV = window.JRF_ENV || shopifyEnv();

  /* ---------- state ---------- */
  var S = { tab: "all", shown: PAGE, pick: {}, cart: { items: [], total_price: 0, total_discount: 0 } };
  var isGift = function (it) { return !!it && (it.product_type === "Free gift" || (!!D.gift && it.product_id === D.gift.productId)); };
  // the belt from the offer after Add to Cart: in the cart at its own price, never counted as a bag
  var isAddon = function (it) { return !!it && !!D.offer && it.product_id === D.offer.productId; };
  var addonLine = function (c) { return (c.items || []).filter(isAddon)[0] || null; };
  var paid = function (c) { return (c.items || []).filter(function (it) { return !isGift(it) && !isAddon(it); }); };
  var paidCount = function (c) { return paid(c).reduce(function (a, it) { return a + it.quantity; }, 0); };
  var giftLine = function (c) { return (c.items || []).filter(isGift)[0] || null; };
  var inCart = function (pid) { return paid(S.cart).filter(function (it) { return it.product_id === pid; }).reduce(function (a, it) { return a + it.quantity; }, 0); };
  var firstAvail = function (p) { for (var i = 0; i < p.v.length; i++) if (p.v[i].a !== false) return i; return 0; };
  var pickOf = function (p) { return p.id in S.pick ? S.pick[p.id] : (S.pick[p.id] = firstAvail(p)); };

  /* What the shopper sees is the cart Shopify last confirmed PLUS the taps still on their way,
     so every tap shows at once. Shopify then confirms the taps one by one, in order, and the
     view settles on its answer. On an error the queue is dropped and the real cart is reloaded. */
  var server = S.cart, pending = [], running = false, wantCheckout = false, errEl = null, raf = 0;
  var copyLine = function (x) { var o = {}; for (var k in x) o[k] = x[k]; return o; };
  function synth(vid) {
    var bv = byVariant[vid]; if (!bv) return null;
    return { key: "jrf-" + vid, id: vid, product_id: bv.p.id, quantity: 1, product_title: bv.p.t, variant_title: bv.p.v.length > 1 ? bv.v.o : null, image: bv.p.i[0], price: bv.v.p, original_price: bv.v.p, product_type: "Bag" };
  }
  function applyTap(c, it) {
    if (it.t === "addon-off") { var ad = addonLine(c); if (ad) c.items.splice(c.items.indexOf(ad), 1); return; }
    var line = c.items.filter(function (x) { return x.id === it.vid && !isGift(x) && !isAddon(x); })[0];
    if (it.t === "add") {
      if (line) line.quantity++; else { var n = synth(it.vid); if (n) c.items.push(n); }
      if (D.gift && !giftLine(c)) c.items.push({ key: "jrf-gift", id: D.gift.variantId, product_id: D.gift.productId, quantity: 1, product_title: D.gift.title, image: D.gift.image, price: 0, original_price: 0, product_type: "Free gift" });
    } else if (line) {
      if (--line.quantity <= 0) c.items.splice(c.items.indexOf(line), 1);
      if (paidCount(c) === 0) c.items = c.items.filter(function (x) { return !isGift(x) && !isAddon(x); });
    }
  }
  function view() {
    if (!pending.length) return server;
    var c = { items: (server.items || []).map(copyLine) };
    pending.forEach(function (it) { applyTap(c, it); });
    c.total_price = extra ? Math.max(0, Math.round((tierLines(c) - extra.amt) * extra.k)) : null;
    return c;
  }
  /* The tiers are not all Shopify takes off: a code from an e-mail or a CS voucher comes on top,
     and Shopify rounds the tier per line. So the price shown at once is the tiers, rounded per
     line, corrected by what Shopify took off on top in the last cart it confirmed. Without that
     the total jumped up on a tap and back down when Shopify answered. */
  function tierLines(c) {
    var t = tierOf(paidCount(c));
    // Shopify rounds the discount AMOUNT per line and takes that off (prices end in 95, so every line is a half penny)
    return paid(c).reduce(function (a, x) { var l = (x.original_price || x.price || 0) * x.quantity; return a + l - Math.round(l * t / 100); }, 0) +
      (c.items || []).filter(isAddon).reduce(function (a, x) { return a + (x.original_price || x.price || 0) * x.quantity; }, 0);
  }
  var extra = { amt: 0, k: 1 };
  function learn(c) {
    if (!c || !c.items) return;
    var codes = (c.discount_codes || []).length > 0;
    if (!paidCount(c)) { extra = codes ? null : { amt: 0, k: 1 }; return; }
    var base = tierLines(c), act = c.total_price || 0;
    if (Math.abs(base - act) <= paid(c).length) { extra = { amt: 0, k: 1 }; return; }
    var amt = (c.cart_level_discount_applications || []).filter(function (a) { return a.value_type === "fixed_amount"; })
      .reduce(function (a, x) { return a + (x.total_allocated_amount || 0); }, 0);
    var rest = base - amt;
    extra = rest > 0 ? { amt: amt, k: act / rest } : { amt: 0, k: base > 0 ? act / base : 1 };
  }
  function setSrv(c) { if (c && c.items) { server = c; learn(c); } }
  function render() {
    S.cart = view();
    if (raf) return;
    var go = function () { raf = 0; refreshCards(); renderPanel(); };
    raf = window.requestAnimationFrame ? requestAnimationFrame(go) : setTimeout(go, 16);
  }
  function tap(it) {
    pending.push(it); if (errEl) errEl.textContent = "";
    render();
    if (!running) drain();
  }
  function send(it) {
    if (it.t === "add") {
      var items = [{ id: it.vid, quantity: 1 }];
      if (D.gift && paidCount(server) === 0 && !giftLine(server)) items.push({ id: D.gift.variantId, quantity: 1 });
      return ENV.add(items).catch(function (e) { if (items.length > 1) return ENV.add([items[0]]); throw e; });
    }
    if (it.t === "addon-off") { var ad = addonLine(server); return ad ? ENV.change(ad.key, 0) : ENV.get(); }
    var line = paid(server).filter(function (x) { return x.id === it.vid; })[0];
    if (!line) return ENV.get();
    // the last bag out takes the gift and the belt with it
    var clear = function (c) {
      if (paidCount(c)) return c;
      var x = giftLine(c) || addonLine(c);
      return x ? ENV.change(x.key, 0).then(clear) : c;
    };
    return ENV.change(line.key, line.quantity - 1).then(clear);
  }
  function drain() {
    if (!pending.length) {
      running = false; render();
      if (ENV.announce) ENV.announce(server);
      if (wantCheckout) { wantCheckout = false; startCheckout(); }
      return;
    }
    running = true;
    send(pending[0]).then(function (c) { setSrv(c); pending.shift(); drain(); }, function (e) {
      pending = []; running = false; wantCheckout = false;
      var msg = e && e.message ? e.message : "Something went wrong. Please try again.";
      ENV.get().then(setSrv, function () {}).then(function () { render(); if (errEl) errEl.textContent = msg; if (ENV.announce) ENV.announce(server); });
    });
  }
  function add(vid) { tap({ t: "add", vid: vid }); }
  function removeOne(pid, vid) {
    var lines = paid(S.cart).filter(function (it) { return it.product_id === pid; });
    var line = lines.filter(function (it) { return it.id === vid; })[0] || lines[lines.length - 1];
    if (line) tap({ t: "dec", vid: line.id });
  }
  function setServer(c) { if (c && c.items) { setSrv(c); render(); } }
  function pull() { if (running || pending.length) return; ENV.get().then(function (c) { if (!running && !pending.length) setServer(c); }, function () {}); }

  /* ---------- tabs ---------- */
  var catsEl = root.querySelector("[data-jrf-cats]");
  var ringFor = function (key) {
    if (D.rings && D.rings[key]) return D.rings[key];
    var list = listFor(key); var p = key === "all" ? (BEST[1] || P[0]) : list[0];
    return p ? p.i[0] : "";
  };
  function listFor(key) {
    var L = key === "all" ? P : key === "best" ? BEST : P.filter(function (p) { return p.c === key; });
    // outside the US and Canada the store hides sold-out bags; so does this page
    return intl() ? L.filter(function (p) { return p.v.some(function (v) { return v.a !== false; }); }) : L;
  }
  catsEl.innerHTML = TABS.filter(function (t) { return listFor(t.key).length; }).map(function (t) {
    return '<button type="button" role="tab" class="jrf-cat' + (t.key === S.tab ? " is-on" : "") + '" data-c="' + t.key + '" aria-selected="' + (t.key === S.tab) + '"><span class="jrf-ring"><img src="' + esc(ringFor(t.key)) + '" alt="" width="120" height="120" loading="lazy"></span><span class="jrf-lb">' + esc(t.label) + "</span></button>";
  }).join("");
  catsEl.addEventListener("click", function (e) {
    var b = e.target.closest(".jrf-cat"); if (!b) return;
    S.tab = b.getAttribute("data-c"); S.shown = PAGE;
    [].forEach.call(catsEl.querySelectorAll(".jrf-cat"), function (x) { var on = x === b; x.classList.toggle("is-on", on); x.setAttribute("aria-selected", on); });
    renderGrid();
  });

  /* ---------- grid ---------- */
  var gridEl = root.querySelector("[data-jrf-grid]"), countEl = root.querySelector("[data-jrf-count]"), moreEl = root.querySelector("[data-jrf-more]"), moreBtn = moreEl.querySelector("button");
  function cardAct(p) {
    var n = inCart(p.id), v = p.v[pickOf(p)];
    if (!n) return v.a === false ? '<button type="button" class="jrf-add" disabled>Sold out</button>' : '<button type="button" class="jrf-add" data-a="+">Add to my bags</button>';
    return '<div class="jrf-step"><button type="button" data-a="-" aria-label="Remove one">−</button><span>✓ ' + (n > 1 ? n + " in bags" : "In bags") + '</span><button type="button" class="is-plus" data-a="+" aria-label="Add one more"' + (v.a === false ? " disabled" : "") + ">+</button></div>";
  }
  function swatches(p) {
    var vi = pickOf(p);
    return p.v.slice(0, 6).map(function (v, i) {
      return '<button type="button" class="jrf-dot' + (i === vi ? " is-on" : "") + (v.a === false ? " is-out" : "") + '" data-a="c" data-v="' + i + '" style="background-color:' + hex(v.o) + '" aria-label="' + esc(v.o) + (v.a === false ? " (sold out)" : "") + '" title="' + esc(v.o) + '"></button>';
    }).join("") + "<small>" + esc(p.v[vi].o) + (p.v[vi].a === false ? " · sold out" : "") + "</small>";
  }
  var picked = {};
  var canHover = window.matchMedia ? window.matchMedia("(hover:hover)").matches : true;
  // the photo of the colour that is picked (falls back to the product photo)
  var vImg = function (p) { var v = p.v[pickOf(p)]; return (v && v.im) || p.i[0]; };
  var fileOf = function (u) { return String(u || "").split("?")[0].split("/").pop(); };
  /* A colour change never shows a half-loaded photo or a jump: the new photo loads off-screen,
     and only once it is decoded does it replace the old one, which fades out on top of it. */
  var setOf = function (u) { return u && u.indexOf("width=600") > -1 ? u.replace("width=600", "width=300") + " 300w, " + u + " 600w" : ""; };
  var warmed = {};
  function warmUrl(u, sizes) {
    if (!u || warmed[u]) return; warmed[u] = 1;
    var im = new Image(), set = setOf(u); if (set && sizes) { im.sizes = sizes; im.srcset = set; } im.src = u;
  }
  var CARD_SIZES = "(min-width:1200px) 270px, (min-width:750px) 31vw, 47vw";
  function warm(p) { p.v.forEach(function (v) { if (v.im) warmUrl(v.im, CARD_SIZES); }); }
  function swapImg(el, u, sizes) {
    if (!el || !u) return;
    var set = sizes ? setOf(u) : "";
    if ((el.getAttribute("src") || "") === u) return;
    el.__want = u;
    var pre = new Image(); if (set) { pre.sizes = sizes; pre.srcset = set; } pre.src = u;
    var go = function () {
      if (el.__want !== u || !el.isConnected) return;
      var par = el.parentNode, ghost = null;
      if (par && el.complete && el.naturalWidth) {
        ghost = el.cloneNode(false);
        ghost.removeAttribute("loading"); ghost.removeAttribute("fetchpriority"); ghost.removeAttribute("data-ubig"); ghost.setAttribute("aria-hidden", "true"); ghost.alt = "";
        ghost.className = el.className + " jrf-ghost";
        ghost.style.cssText = "position:absolute;left:" + el.offsetLeft + "px;top:" + el.offsetTop + "px;width:" + el.offsetWidth + "px;height:" + el.offsetHeight + "px;margin:0;pointer-events:none;opacity:1;transition:opacity .26s ease";
        if (window.getComputedStyle && getComputedStyle(par).position === "static") par.style.position = "relative";
        par.insertBefore(ghost, el.nextSibling);
      }
      if (set) { el.sizes = sizes; el.srcset = set; } else el.removeAttribute("srcset");
      el.src = u;
      if (ghost) {
        var fade = function () { ghost.style.opacity = "0"; setTimeout(function () { if (ghost.parentNode) ghost.parentNode.removeChild(ghost); }, 320); };
        if (window.requestAnimationFrame) requestAnimationFrame(function () { requestAnimationFrame(fade); }); else fade();
      }
    };
    if (pre.decode) pre.decode().then(go, go); else { pre.onload = pre.onerror = go; }
  }
  function setImg(el, u) { swapImg(el, u, CARD_SIZES); }
  // Shopify's CDN: the 600px URL from Liquid also exists at 300px; phones take the small one.
  var srcset = function (u) { return u && u.indexOf("width=600") > -1 ? ' srcset="' + esc(u.replace("width=600", "width=300")) + " 300w, " + esc(u) + ' 600w" sizes="(min-width:1200px) 270px, (min-width:750px) 31vw, 47vw"' : ""; };
  function cardHtml(p, idx) {
    return '<div class="jrf-card' + (inCart(p.id) ? " is-sel" : "") + '" data-id="' + p.id + '">' +
      '<button type="button" class="jrf-im" data-a="i" aria-label="View ' + esc(p.city) + '">' +
      '<img class="jrf-main" src="' + esc(vImg(p)) + '"' + srcset(vImg(p)) + ' width="600" height="600" decoding="async" alt="' + esc(p.city + " " + p.type) + '"' + (idx < 4 ? "" : ' loading="lazy"') + ">" +
      (canHover && !picked[p.id] && p.i[1] ? '<img class="jrf-alt" src="' + esc(p.i[1]) + '"' + srcset(p.i[1]) + ' width="600" height="600" decoding="async" alt="" loading="lazy">' : "") +
      (tagged[p.id] ? '<span class="jrf-btag">Bestseller</span>' : "") + '<span class="jrf-qb">✓</span><span class="jrf-eye" aria-hidden="true">i</span></button>' +
      '<div class="jrf-nm"><b>' + esc(p.city) + "</b><span>" + esc(p.type) + "</span></div>" +
      '<div class="jrf-pr jrf-money">' + money(p.p) + (cmpOf(p.p, p.cp) ? "<s>" + money(cmpOf(p.p, p.cp)) + "</s>" : "") + "</div>" +
      '<div class="jrf-sw">' + swatches(p) + "</div>" +
      '<div class="jrf-act">' + cardAct(p) + "</div></div>";
  }
  function renderGrid(append) {
    var L = listFor(S.tab), have = gridEl.children.length;
    countEl.textContent = L.length + (L.length === 1 ? " bag" : " bags");
    if (append && have) gridEl.insertAdjacentHTML("beforeend", L.slice(have, S.shown).map(function (p, i) { return cardHtml(p, have + i); }).join(""));
    else gridEl.innerHTML = L.slice(0, S.shown).map(cardHtml).join("");
    var left = L.length - S.shown;
    moreEl.hidden = left <= 0; moreEl.style.display = left <= 0 ? "none" : "";
    moreBtn.textContent = "Show " + Math.min(PAGE, Math.max(left, 0)) + " more";
    watchCards();
  }
  // only touch the cards whose button actually changed
  function refreshCards() {
    [].forEach.call(gridEl.querySelectorAll(".jrf-card"), function (c) {
      var p = byId[c.getAttribute("data-id")]; if (!p) return;
      var html = cardAct(p), act = c.querySelector(".jrf-act");
      if (act.__html === html) return;
      act.__html = html; act.innerHTML = html;
      c.classList.toggle("is-sel", inCart(p.id) > 0);
    });
  }
  moreBtn.addEventListener("click", function () { S.shown += PAGE; renderGrid(true); });
  var warmFrom = function (e) { var c = e.target.closest && e.target.closest(".jrf-card"); if (c && e.target.closest(".jrf-sw")) { var p = byId[c.getAttribute("data-id")]; if (p) warm(p); } };
  gridEl.addEventListener("pointerover", warmFrom, { passive: true });
  gridEl.addEventListener("touchstart", warmFrom, { passive: true });
  var dwell = window.IntersectionObserver ? new IntersectionObserver(function (ents) {
    ents.forEach(function (en) {
      var c = en.target;
      if (en.isIntersecting) c.__dw = setTimeout(function () { var p = byId[c.getAttribute("data-id")]; if (p) warm(p); dwell.unobserve(c); }, 600);
      else clearTimeout(c.__dw);
    });
  }, { threshold: 0.6 }) : null;
  function watchCards() { if (dwell) [].forEach.call(gridEl.querySelectorAll(".jrf-card"), function (c) { if (!c.__dwOn) { c.__dwOn = 1; dwell.observe(c); } }); }
  gridEl.addEventListener("click", function (e) {
    var b = e.target.closest("[data-a]"); if (!b || b.disabled) return;
    var c = b.closest(".jrf-card"), p = byId[c.getAttribute("data-id")], a = b.getAttribute("data-a");
    if (a === "i") return openQV(p);
    if (a === "c") { S.pick[p.id] = +b.getAttribute("data-v"); picked[p.id] = 1; var alt = c.querySelector(".jrf-alt"); if (alt) alt.parentNode.removeChild(alt); c.querySelector(".jrf-sw").innerHTML = swatches(p); var act = c.querySelector(".jrf-act"); act.__html = cardAct(p); act.innerHTML = act.__html; setImg(c.querySelector(".jrf-main"), vImg(p)); return; }
    if (a === "+") return add(p.v[pickOf(p)].id);
    if (a === "-") return removeOne(p.id, p.v[pickOf(p)].id);
  });

  /* ---------- panel (the cart) ---------- */
  var panelEl = root.querySelector("[data-jrf-panel]"), bodyEl = root.querySelector("[data-jrf-pbody]");
  var phone = window.matchMedia ? window.matchMedia("(max-width:989px)") : { matches: false };
  var ctaEl = root.querySelector("[data-jrf-cta]"), formEl = root.querySelector("[data-jrf-form]");
  var img = function (u, w) { if (!u) return ""; return u.indexOf("cdn.shopify.com") > -1 || u.indexOf("/cdn/shop/") > -1 ? u + (u.indexOf("?") > -1 ? "&" : "?") + "width=" + (w || 120) : u; };
  var lineName = function (it) { var bv = byVariant[it.id]; return bv ? bv.p.city : String(it.product_title || it.title || "").split("|").pop().trim(); };
  // Vera's wording, from the tiers: what the next tier is and how many bags it takes
  var TIERS = [{ qty: 2, pct: 20 }, { qty: 3, pct: 25 }, { qty: 4, pct: 30 }];
  function nextMsg(n) {
    var nx = null; for (var i = 0; i < TIERS.length; i++) if (n < TIERS[i].qty) { nx = TIERS[i]; break; }
    if (!nx) return "You unlocked the biggest discount: <b>an extra " + TIERS[TIERS.length - 1].pct + "% off</b>";
    var k = nx.qty - n, bags = k + " " + (n ? "more " : "") + (k === 1 ? "bag" : "bags");
    return "Add " + bags + (n ? " → unlock" : " to unlock") + " <b>an extra " + nx.pct + "% off</b>";
  }
  function renderPanel() {
    var c = S.cart, items = paid(c), n = paidCount(c), t = tierOf(n), g = giftLine(c);
    var cmp = 0; items.forEach(function (it) { var bv = byVariant[it.id]; var base = it.original_price || it.price, cc = bv ? cmpOf(bv.v.p || base, bv.v.c) : cmpOf(base, 0); cmp += (cc || base) * it.quantity; });
    (c.items || []).filter(isAddon).forEach(function (it) { var ov = D.offer.v.filter(function (v) { return v.id === it.id; })[0], b = it.original_price || it.price; cmp += (ov && ov.c > b ? ov.c : b) * it.quantity; });
    var total = n ? c.total_price : 0, known = total !== null && total !== undefined;
    if (!known) total = 0;
    var thumbs = [], rows = [];
    items.forEach(function (it) {
      var name = esc(lineName(it)), pic = esc(img(it.image, 140));
      thumbs.push('<div class="jrf-th"><img src="' + pic + '" alt="' + name + '">' + (it.quantity > 1 ? '<span class="jrf-n">×' + it.quantity + "</span>" : "") +
        '<button type="button" data-x="' + it.id + '" aria-label="Remove one ' + name + '">×</button></div>');
      rows.push('<div class="jrf-li"><img src="' + pic + '" alt=""><div class="jrf-lt"><b>' + name + "</b><span>" + esc(it.variant_title || "") + (it.variant_title ? " · " : "") + money(it.original_price || it.price) + "</span></div>" +
        '<div class="jrf-mini"><button type="button" data-m="-" data-v="' + it.id + '" aria-label="Remove one">−</button><span>' + it.quantity + '</span><button type="button" data-m="+" data-v="' + it.id + '" aria-label="Add one">+</button></div></div>');
    });
    if (g) {
      var gimg = esc(img(g.image || (D.gift && D.gift.image), 140)), gname = esc(D.gift && D.gift.title || g.product_title);
      thumbs.push('<div class="jrf-th is-gift" title="Free gift"><img src="' + gimg + '" alt="' + gname + '"><span class="jrf-ftag">FREE</span></div>');
      rows.push('<div class="jrf-li is-gift"><img src="' + gimg + '" alt=""><div class="jrf-lt"><b>' + gname.toUpperCase() + '</b><span>Free with your order</span></div><div class="jrf-free">' + (D.gift && D.gift.compare ? "<s>" + money(D.gift.compare) + "</s>" : "") + "<b>FREE</b></div></div>");
    }
    var ad = addonLine(c);
    if (ad) {
      var aname = esc(nameParts(ad.product_title || (D.offer && D.offer.title) || "Belt").city), aimg = esc(img(ad.image, 140));
      thumbs.push('<div class="jrf-th"><img src="' + aimg + '" alt="' + aname + '"><button type="button" data-xa aria-label="Remove ' + aname + '">×</button></div>');
      rows.push('<div class="jrf-li"><img src="' + aimg + '" alt=""><div class="jrf-lt"><b>' + aname + "</b><span>" + esc(ad.variant_title || "") + (ad.variant_title ? " · " : "") + money(ad.original_price || ad.price) + '</span></div><div class="jrf-mini"><button type="button" data-xa aria-label="Remove ' + aname + '">×</button></div></div>');
    }
    var segs = "", lbs = "";
    for (var i = 1; i <= 4; i++) { segs += '<i class="' + (n >= i ? "is-on" : "") + '"></i>'; lbs += '<span class="' + (n >= i ? "is-on" : "") + '">' + (i === 1 ? "1 bag" : i === 2 ? "−20%" : i === 3 ? "−25%" : "−30%") + "</span>"; }
    panelEl.classList.toggle("is-empty", !n);
    bodyEl.innerHTML =
      '<div class="jrf-ptop"><div class="jrf-pttl">Your Bags <span class="jrf-pcnt">' + n + (n === 1 ? " bag" : " bags") + "</span></div>" +
      '<div class="jrf-ptot jrf-money">' + (n && known && cmp > total ? "<s>" + money(cmp) + "</s>" : "") + "<b>" + (known ? money(total) : "…") + "</b></div></div>" +
      '<div class="jrf-prog" aria-hidden="true">' + segs + '</div><div class="jrf-prog-lb" aria-hidden="true">' + lbs + "</div>" +
      '<div class="jrf-msg">' + nextMsg(n) + "</div>" +
      '<div class="jrf-thumbs">' + thumbs.join("") + "</div>" +
      (g ? '<div class="jrf-giftline"><svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M4 11h16v9H4zM3 7h18v4H3zM12 7v13M12 7c-1.6-3.4-5.6-3.4-5.6-1 0 1.6 2.6 1 5.6 1zm0 0c1.6-3.4 5.6-3.4 5.6-1 0 1.6-2.6 1-5.6 1z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg><span><b>' + gname + "</b> added to your bags. Free" + (D.gift && D.gift.compare ? ' <s>' + money(D.gift.compare) + "</s>" : "") + "</span></div>" : "") +
      (n ? '<div class="jrf-list">' + rows.join("") + "</div>" : '<div class="jrf-empty">No bags yet. Tap <b>Add to my bags</b> on any bag' + (D.gift ? ", and a free gift comes with your first one." : ".") + "</div>") +
      '<div class="jrf-err" data-jrf-err role="alert"></div>';
    errEl = bodyEl.querySelector("[data-jrf-err]");
    ctaEl.disabled = !n;
    ctaEl.textContent = wantCheckout ? "Opening checkout…" : n ? "Add to Cart" + (known ? " · " + money(total) : "") : "Add a bag to start";
    if (window.requestAnimationFrame) requestAnimationFrame(padForBar); else padForBar();
  }
  // The bar is fixed to the screen on phones, so the page needs its height as room at the end.
  function padForBar() {
    document.body.style.paddingBottom = phone.matches && paidCount(S.cart) ? (panelEl.querySelector(".jrf-box").offsetHeight + 24) + "px" : "";
  }
  if (phone.addEventListener) phone.addEventListener("change", padForBar);
  bodyEl.addEventListener("click", function (e) {
    if (e.target.closest("[data-xa]")) return tap({ t: "addon-off" });
    var x = e.target.closest("[data-x]"); if (x) return tap({ t: "dec", vid: +x.getAttribute("data-x") });
    var m = e.target.closest("[data-m]"); if (!m) return;
    tap({ t: m.getAttribute("data-m") === "+" ? "add" : "dec", vid: +m.getAttribute("data-v") });
  });
  // The checkout button is a plain cart form submit (name="checkout"), exactly like the
  // cart drawer's, so the store's checkout script picks it up the same way.
  // A tap on the button while bags are still on their way to Shopify waits for them (window,
  // capture: before any other checkout handler), then clicks again, so checkout has every bag.
  // "Add to Cart" is a plain button: bags still on their way are waited for, then the offer,
  // then the hidden real checkout button is pressed (Accept or Decline both go on to checkout).
  var goEl = root.querySelector("[data-jrf-go]");
  ctaEl.addEventListener("click", function (e) {
    e.preventDefault();
    if (!paidCount(S.cart)) return;
    if (pending.length || running) { wantCheckout = true; ctaEl.textContent = "Opening checkout…"; return; }
    startCheckout();
  });
  function startCheckout() { if (!paidCount(server)) return; if (offerFirst()) return openOffer(); goOn(); }

  /* ---------- the offer after Add to Cart (Vera's Copper "WAIT!!", same urgency) ----------
     One belt Neil makes, at its own offer price (the product itself is priced at the offer;
     the higher price is its compare-at). Add to order puts it in the cart and goes on to
     checkout; Decline, the × or Escape go straight on. */
  var OFFER = D.offer && D.offer.v && D.offer.v.length ? D.offer : null;
  // "Leather Ratchet Belt | ABILENE" → city + type, the way every bag is shown
  var nameParts = function (t) { var x = String(t || "").split("|"); return { type: x[0].trim(), city: (x[1] || x[0]).trim() }; };
  var OFFER_COPY = {
    headline: "WAIT!!",
    sub: '<b>Holes wear out. This belt has none.</b> It clicks to your exact fit in <b class="jrf-uhot">one second.</b>',
    bullets: [
      "\ud83c\udfaf No holes: the ratchet clicks to your exact fit, every time",
      "\ud83d\udc02 Genuine cow leather with a solid metal buckle",
      "\u23f0 10-year buckle warranty. The last belt you'll need to buy"
    ],
    minutes: 10
  };
  var uo = null, uTick = 0;
  function offerFirst() { return !!OFFER && paidCount(server) > 0 && !addonLine(server) && OFFER.v.some(function (v) { return v.a !== false; }); }
  function goOn() { if (goEl) goEl.click(); else formEl.submit(); }
  function uoKey(e) { if (e.key === "Escape") { closeOffer(); goOn(); } }
  function closeOffer() {
    if (!uo) return;
    clearInterval(uTick); var v = uo.querySelector("video"); if (v) try { v.pause(); } catch (e) {}
    uo.remove(); uo = null;
    unlockScroll(); document.removeEventListener("keydown", uoKey);
  }
  function openOffer() {
    var O = OFFER, nm = nameParts(O.title);
    var vi = 0; for (var i = 0; i < O.v.length; i++) if (O.v[i].a !== false) { vi = i; break; }
    // the gallery: the chosen colour's photo first, then the other photos and the film (not the other colour)
    var varFiles = O.v.map(function (v) { return fileOf(v.im); });
    var media = (O.m || (O.imgs || []).map(function (u) { return { t: "i", u: u }; })).filter(Boolean);
    var extra = media.filter(function (x) { return !(x.t === "i" && varFiles.indexOf(fileOf(x.u)) > -1); }).slice(0, 5);
    var gal = [{ t: "i", u: O.v[vi].im || (media[0] && media[0].u) }].concat(extra);
    var cur = 0, left = Math.max(1, OFFER_COPY.minutes) * 60;
    var fmt = function (t) { var m = Math.floor(t / 60), s2 = t % 60; return m + ":" + (s2 < 10 ? "0" : "") + s2; };
    var acts = '<button type="button" class="jrf-uyes" data-u="yes">Add to order</button><button type="button" class="jrf-uno" data-u="no">Decline this offer</button>';
    uo = document.createElement("div");
    uo.className = "jrf jrf-uo"; uo.setAttribute("role", "dialog"); uo.setAttribute("aria-modal", "true"); uo.setAttribute("aria-label", "One-time offer");
    uo.innerHTML = '<div class="jrf-ubox">' +
      '<button type="button" class="jrf-ux" data-u="no" aria-label="Close">×</button>' +
      '<div class="jrf-uhd"><p class="jrf-uh1">' + esc(OFFER_COPY.headline) + '</p><p class="jrf-usub">' + OFFER_COPY.sub + "</p></div>" +
      '<div class="jrf-utimer"><span>Special offer ends in</span> <i data-uclock>' + fmt(left) + "</i></div>" +
      '<div class="jrf-ubody"><div class="jrf-umed"><div class="jrf-ustage"><img class="jrf-ubig" data-ubig src="" alt="' + esc(nm.city + " " + nm.type) + '" fetchpriority="high">' +
        '<video class="jrf-ubig jrf-uvid" data-uvid muted loop playsinline preload="none" hidden></video>' +
        (gal.length > 1 ? '<button type="button" class="jrf-uarr is-prev" data-u="prev" aria-label="Previous">‹</button><button type="button" class="jrf-uarr is-next" data-u="next" aria-label="Next">›</button>' : "") + "</div>" +
        (gal.length > 1 ? '<div class="jrf-uthumbs" data-uthumbs></div>' : "") +
      '</div><div class="jrf-uinfo"><p class="jrf-ut">' + esc(nm.city) + (nm.type !== nm.city ? "<span>" + esc(nm.type) + "</span>" : "") + '</p><ul class="jrf-uul">' + OFFER_COPY.bullets.map(function (b) { return "<li>" + esc(b) + "</li>"; }).join("") + "</ul>" +
        (O.v.length > 1 ? '<div class="jrf-ucol" data-ucol></div>' : "") +
        '<div class="jrf-uprice jrf-money" data-uprice></div><div class="jrf-uacts">' + acts + "</div></div></div>" +
      '<div class="jrf-ufoot"><button type="button" class="jrf-uno" data-u="no">Decline this offer</button><button type="button" class="jrf-uyes" data-u="yes">Add to order</button></div></div>';
    var big = uo.querySelector("[data-ubig]"), vid = uo.querySelector("[data-uvid]");
    function thumbs() {
      var th = uo.querySelector("[data-uthumbs]"); if (!th) return;
      th.innerHTML = gal.map(function (x, k) {
        return '<button type="button" class="jrf-utb' + (k === cur ? " is-on" : "") + (x.t === "v" ? " is-vid" : "") + '" data-uk="' + k + '" aria-label="' + (x.t === "v" ? "Film" : "Photo " + (k + 1)) + '"><img src="' + esc(x.t === "v" ? x.p : x.u) + '" alt="" loading="lazy"></button>';
      }).join("");
    }
    function show(k) {
      if (!gal.length) return;
      cur = (k + gal.length) % gal.length; var x = gal[cur];
      if (x.t === "v") {
        if (vid.getAttribute("src") !== x.u) { vid.setAttribute("poster", x.p || ""); vid.src = x.u; }
        vid.hidden = false; big.hidden = true; try { var pr = vid.play(); if (pr && pr.catch) pr.catch(function () {}); } catch (e3) {}
      } else {
        if (!vid.hidden) { try { vid.pause(); } catch (e4) {} vid.hidden = true; }
        big.hidden = false; swapImg(big, x.u);
      }
      [].forEach.call(uo.querySelectorAll(".jrf-utb"), function (b, j) { b.classList.toggle("is-on", j === cur); });
    }
    function paint() {
      var v = O.v[vi], col = uo.querySelector("[data-ucol]");
      if (col) col.innerHTML = '<span>Color: <b>' + esc(v.o) + "</b></span>" + O.v.map(function (x, k) {
        return '<button type="button" class="jrf-uchip' + (k === vi ? " is-on" : "") + '" data-uv="' + k + '"' + (x.a === false ? " disabled" : "") + ' aria-label="' + esc(x.o) + '">' +
          (x.im ? '<img src="' + esc(x.im) + '" alt="" loading="lazy">' : '<i style="background-color:' + hex(x.o) + '"></i>') + "<em>" + esc(x.o) + "</em></button>";
      }).join("");
      uo.querySelector("[data-uprice]").innerHTML = (v.c > v.p ? '<span class="jrf-uwas">' + money(v.c) + "</span>" : "") +
        '<span class="jrf-unow">' + money(v.p) + "</span>" + (v.c > v.p ? '<span class="jrf-usave">Savings: ' + money(v.c - v.p) + "</span>" : "");
    }
    // the chosen colour's photo is always slide 1 of the gallery
    function toVariant() { if (O.v[vi].im) gal[0] = { t: "i", u: O.v[vi].im }; thumbs(); show(0); }
    paint(); thumbs(); show(0);
    gal.forEach(function (x) { if (x.t === "i") warmUrl(x.u); });
    uo.addEventListener("click", function (e) {
      var t = e.target.closest("[data-uk]"); if (t) return show(+t.getAttribute("data-uk"));
      var c = e.target.closest("[data-uv]"); if (c) { vi = +c.getAttribute("data-uv"); paint(); return toVariant(); }
      var a = e.target.closest("[data-u]"); if (!a) return;
      var act = a.getAttribute("data-u");
      if (act === "prev") return show(cur - 1);
      if (act === "next") return show(cur + 1);
      if (act === "no") { closeOffer(); return goOn(); }
      if (act !== "yes") return;
      [].forEach.call(uo.querySelectorAll(".jrf-uyes"), function (b) { b.disabled = true; b.textContent = "Adding…"; });
      [].forEach.call(uo.querySelectorAll(".jrf-uno"), function (b) { b.disabled = true; });
      ENV.add([{ id: O.v[vi].id, quantity: 1 }]).then(function (c) { setServer(c); if (ENV.announce) ENV.announce(server); }, function () {})
        .then(function () { closeOffer(); goOn(); });
    });
    uTick = setInterval(function () {
      left--; if (left <= 0) { left = 0; clearInterval(uTick); }
      if (uo) uo.querySelector("[data-uclock]").textContent = fmt(left);
    }, 1000);
    lockScroll();
    document.addEventListener("keydown", uoKey);
    document.body.appendChild(uo);
    var y = uo.querySelector(".jrf-uyes"); if (y) try { y.focus({ preventScroll: true }); } catch (e2) {}
  }
  formEl.addEventListener("submit", function (e) {
    if (pending.length || running) { e.preventDefault(); wantCheckout = true; return; }
    if (!paidCount(S.cart)) { e.preventDefault(); return; }
    if (ENV.checkout) ENV.checkout(e, S.cart);
  });

  /* ---------- quick view ---------- */
  var LABELS = ["size and dimensions", "weight and capacity", "main materials", "lining", "interior features", "exterior features", "closure", "handles/straps", "style", "type", "recommended use", "each piece"];
  function spec(text, label) {
    var lo = text.toLowerCase(), i = lo.indexOf(label); if (i < 0) return null;
    var rest = text.slice(i + label.length).replace(/^\s*:\s*/, ""), end = rest.length, rl = rest.toLowerCase();
    LABELS.forEach(function (l) { var j = rl.indexOf(l); if (j > 0 && j < end) end = j; });
    var s = rest.slice(0, end).trim().replace(/\s*\|\s*/g, " / ");
    return s ? s.charAt(0).toUpperCase() + s.slice(1) : null;
  }
  var ov = null;
  /* While the info sheet or the offer is open the page behind it must not move. overflow:hidden
     alone does not stop iOS Safari, so the body is pinned where it is and put back on close. */
  var locks = 0, lockY = 0, lockPrev = null;
  function lockScroll() {
    if (locks++) return;
    var b = document.body, h = document.documentElement;
    lockY = window.pageYOffset || h.scrollTop || 0;
    lockPrev = { pos: b.style.position, top: b.style.top, left: b.style.left, right: b.style.right, width: b.style.width, ov: h.style.overflow };
    h.style.overflow = "hidden";
    b.style.position = "fixed"; b.style.top = -lockY + "px"; b.style.left = "0"; b.style.right = "0"; b.style.width = "100%";
  }
  function unlockScroll() {
    if (!locks || --locks) return;
    var b = document.body, h = document.documentElement, p = lockPrev || {};
    b.style.position = p.pos || ""; b.style.top = p.top || ""; b.style.left = p.left || ""; b.style.right = p.right || ""; b.style.width = p.width || "";
    h.style.overflow = p.ov || "";
    var sb = h.style.scrollBehavior; h.style.scrollBehavior = "auto"; window.scrollTo(0, lockY); h.style.scrollBehavior = sb;
  }
  function closeOv() { if (ov) { ov.remove(); ov = null; document.removeEventListener("keydown", onKey); unlockScroll(); } }
  function onKey(e) { if (e.key === "Escape") closeOv(); }
  var I_RULER = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 8h18v8H3z"/><path d="M7 8v3M11 8v4M15 8v3M19 8v4"/></svg>';
  function openSheet(p) {
    closeOv();
    var imgs = p.i.slice(), cur = 0;
    var at = function (u) { var f = fileOf(u); for (var k = 0; k < imgs.length; k++) if (fileOf(imgs[k]) === f) return k; return -1; };
    ov = document.createElement("div"); ov.className = "jrf jrf-ov jrf-ov--sheet";
    var pcmp = cmpOf(p.p, p.cp), save = savePct(p.p, pcmp);
    ov.innerHTML = '<div class="jrf-mod jrf-mod--sheet" role="dialog" aria-modal="true" aria-label="' + esc(p.city) + '"><button type="button" class="jrf-x" data-close aria-label="Close">×</button>' +
      '<div class="jrf-gal"><img class="jrf-qmain" src="' + esc(vImg(p)) + '" alt="' + esc(p.city + " " + p.type) + '"><div data-q-nav></div></div>' +
      '<div class="jrf-qthumbs" data-q-thumbs></div>' +
      '<div class="jrf-qh">' + esc(p.city) + '</div><div class="jrf-qtype">' + esc(p.type) + "</div>" +
      '<div class="jrf-qpr jrf-money">' + money(p.p) + (save ? "<s>" + money(pcmp) + '</s><span class="jrf-save">Save ' + save + "%</span>" : "") + "</div>" +
      '<div class="jrf-chip" data-q-chip>' + I_RULER + "<span>One size · just pick your color</span></div>" +
      '<div class="jrf-sw jrf-qsw" data-q-sw></div><div data-q-act></div>' +
      '<a class="jrf-qlink" href="' + esc(p.u) + '">See the full details →</a></div>';
    document.body.appendChild(ov); document.addEventListener("keydown", onKey); lockScroll();
    var mainImg = ov.querySelector(".jrf-qmain");
    function gallery() {
      var n = imgs.length;
      ov.querySelector("[data-q-nav]").innerHTML = n > 1 ? '<button type="button" class="jrf-arr is-prev" data-go="-1" aria-label="Previous photo">‹</button><button type="button" class="jrf-arr is-next" data-go="1" aria-label="Next photo">›</button><span class="jrf-ctr">' + (cur + 1) + " / " + n + "</span>" : "";
      ov.querySelector("[data-q-thumbs]").innerHTML = n > 1 ? imgs.map(function (s, k) { return '<button type="button" class="' + (k === cur ? "is-on" : "") + '" data-k="' + k + '" aria-label="Photo ' + (k + 1) + '"><img src="' + esc(s) + '" alt=""></button>'; }).join("") : "";
    }
    function show(k) {
      var n = imgs.length; if (!n) return;
      cur = (k + n) % n; swapImg(mainImg, imgs[cur]);
      var ctr = ov.querySelector(".jrf-ctr"); if (ctr) ctr.textContent = (cur + 1) + " / " + n;
      var th = ov.querySelectorAll("[data-k]");
      [].forEach.call(th, function (b, j) { b.classList.toggle("is-on", j === cur); });
      if (th[cur] && th[cur].scrollIntoView) th[cur].scrollIntoView({ block: "nearest", inline: "center" });
      var ahead = imgs[(cur + 1) % n]; if (ahead) { var pre = new Image(); pre.src = ahead; }
    }
    function paint() {
      var vi = pickOf(p), v = p.v[vi];
      ov.querySelector("[data-q-sw]").innerHTML = p.v.length > 1 ? swatches(p) : "";
      ov.querySelector("[data-q-act]").innerHTML = v.a === false ? '<button type="button" class="jrf-add jrf-madd" disabled>Sold out</button>' : '<button type="button" class="jrf-add jrf-madd" data-q-add>Add to my bags · ' + money(v.p || p.p) + "</button>";
    }
    function toPhoto() { var u = vImg(p), k = at(u); if (k > -1) show(k); else swapImg(mainImg, u); }
    cur = Math.max(0, at(vImg(p)));
    gallery(); paint();
    ENV.details(p).then(function (d) {
      if (!ov) return;
      var size = spec(d.text || "", "size and dimensions");
      if (size) ov.querySelector("[data-q-chip] span").textContent = size.split(" / ")[0].replace(/\s*x\s*/g, " × ");
      if (d.imgs && d.imgs.length) { imgs = d.imgs; var k = at(vImg(p)); cur = Math.max(0, k); swapImg(mainImg, k > -1 ? imgs[k] : vImg(p)); gallery(); }
    }, function () {});
    ov.addEventListener("click", function (e) {
      if (e.target === ov || e.target.closest("[data-close]")) return closeOv();
      var g = e.target.closest("[data-go]"); if (g) return show(cur + (+g.getAttribute("data-go")));
      var t = e.target.closest("[data-k]"); if (t) return show(+t.getAttribute("data-k"));
      var d = e.target.closest(".jrf-dot"); if (d) { S.pick[p.id] = +d.getAttribute("data-v"); paint(); toPhoto(); var cs = gridEl.querySelector('.jrf-card[data-id="' + p.id + '"]'); picked[p.id] = 1; if (cs) { var csa = cs.querySelector(".jrf-alt"); if (csa) csa.parentNode.removeChild(csa); cs.querySelector(".jrf-sw").innerHTML = swatches(p); var ca = cs.querySelector(".jrf-act"); ca.__html = cardAct(p); ca.innerHTML = ca.__html; setImg(cs.querySelector(".jrf-main"), vImg(p)); } return; }
      if (e.target.closest("[data-q-add]")) { add(p.v[pickOf(p)].id); closeOv(); }
    });
    // swipe on the main photo, as on Vera's sheet
    var x0 = null, gal = ov.querySelector(".jrf-gal");
    gal.addEventListener("touchstart", function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    gal.addEventListener("touchend", function (e) { if (x0 === null || imgs.length < 2) return; var dx = e.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1)); });
    ov.querySelector(".jrf-x").focus();
  }

  /* Laptop and tablet: the two-column card (photos left; colours, description and sizes right). */
  function openDesk(p) {
    closeOv();
    ov = document.createElement("div"); ov.className = "jrf jrf-ov";
    var pcmp = cmpOf(p.p, p.cp), save = savePct(p.p, pcmp);
    ov.innerHTML = '<div class="jrf-mod jrf-mod--desk" role="dialog" aria-modal="true" aria-label="' + esc(p.city) + '"><button type="button" class="jrf-x" aria-label="Close">×</button>' +
      '<div class="jrf-qimgs"><img class="jrf-qmain" src="' + esc(vImg(p)) + '" alt="' + esc(p.city + " " + p.type) + '"><div class="jrf-qthumbs"></div></div>' +
      '<div class="jrf-qbody"><h3>' + esc(p.city) + '</h3><div class="jrf-qtype">' + esc(p.type) + "</div>" +
      '<div class="jrf-qpr jrf-money">' + money(p.p) + (save ? "<s>" + money(pcmp) + '</s><span class="jrf-save">Save ' + save + "%</span>" : "") + "</div>" +
      '<div class="jrf-sw" data-q-sw></div><div data-q-desc></div><div data-q-act></div>' +
      '<a class="jrf-qlink" href="' + esc(p.u) + '">See every photo on the full page →</a></div></div>';
    document.body.appendChild(ov); document.addEventListener("keydown", onKey); lockScroll();
    ov.querySelector(".jrf-x").focus();
    var paint = function () {
      var v = p.v[pickOf(p)], n = inCart(p.id);
      ov.querySelector("[data-q-sw]").innerHTML = swatches(p);
      ov.querySelector("[data-q-act]").innerHTML = (v.a === false ? '<button type="button" class="jrf-add" disabled>Sold out</button>' : '<button type="button" class="jrf-add" data-q-add>Add ' + esc(v.o) + " to my bags</button>") + (n ? '<p class="jrf-qlink" style="margin-top:8px">✓ ' + n + " already in your bags</p>" : "");
    };
    var setImgs = function (list) {
      ov.querySelector(".jrf-qthumbs").innerHTML = list.map(function (s, i) { return '<button type="button" class="' + (i ? "" : "is-on") + '" data-img="' + esc(s) + '"><img src="' + esc(s) + '" alt=""></button>'; }).join("");
    };
    var toVariantPhoto = function () {
      var u = vImg(p), hit = null;
      [].forEach.call(ov.querySelectorAll("[data-img]"), function (b) { var on = fileOf(b.getAttribute("data-img")) === fileOf(u); b.classList.toggle("is-on", on); if (on && !hit) hit = b; });
      swapImg(ov.querySelector(".jrf-qmain"), hit ? hit.getAttribute("data-img") : u);
    };
    paint(); setImgs(p.i); toVariantPhoto();
    ENV.details(p).then(function (d) {
      if (!ov) return;
      var t = d.text || "", mt = t.match(/^[\s\S]*?[.!?](?=\s|$)/), blurb = (mt ? mt[0] : t).slice(0, 260);
      var rows = [["Size", spec(t, "size and dimensions")], ["Weight", spec(t, "weight and capacity")], ["Materials", spec(t, "main materials")], ["Lining", spec(t, "lining")], ["Inside", spec(t, "interior features")]].filter(function (r) { return r[1]; });
      ov.querySelector("[data-q-desc]").innerHTML = (blurb ? '<p style="color:#3b342d">' + esc(blurb) + "</p>" : "") + (rows.length ? "<dl>" + rows.map(function (r) { return "<dt>" + r[0] + "</dt><dd>" + esc(r[1]) + "</dd>"; }).join("") + "</dl>" : "");
      if (d.imgs && d.imgs.length) { setImgs(d.imgs); toVariantPhoto(); }
    }, function () {});
    ov.addEventListener("click", function (e) {
      if (e.target === ov || e.target.closest(".jrf-x")) return closeOv();
      var d = e.target.closest(".jrf-dot"); if (d) { S.pick[p.id] = +d.getAttribute("data-v"); paint(); refreshCards(); var cs = gridEl.querySelector('.jrf-card[data-id="' + p.id + '"]'); picked[p.id] = 1; if (cs) { var csa = cs.querySelector(".jrf-alt"); if (csa) csa.parentNode.removeChild(csa); cs.querySelector(".jrf-sw").innerHTML = swatches(p); setImg(cs.querySelector(".jrf-main"), vImg(p)); } toVariantPhoto(); return; }
      var t = e.target.closest("[data-img]"); if (t) { swapImg(ov.querySelector(".jrf-qmain"), t.getAttribute("data-img")); [].forEach.call(ov.querySelectorAll("[data-img]"), function (b) { b.classList.toggle("is-on", b === t); }); return; }
      if (e.target.closest("[data-q-add]")) { add(p.v[pickOf(p)].id); paint(); }
    });
  }
  var sheetMQ = window.matchMedia ? window.matchMedia("(max-width:699px)") : { matches: false };
  function openQV(p) { return sheetMQ.matches ? openSheet(p) : openDesk(p); }

  /* ---------- keep in step with the rest of the store ---------- */
  document.addEventListener("cart:updated", function (e) {
    if (running || pending.length || (e.detail && e.detail.source === "jrf")) return;
    if (e.detail && e.detail.cart && e.detail.cart.items) setServer(e.detail.cart); else pull();
  });
  ["ajaxProduct:added", "drawerClose", "cart:closed"].forEach(function (ev) { document.addEventListener(ev, pull); });
  window.addEventListener("pageshow", function (e) { if (e.persisted) pull(); });
  document.addEventListener("visibilitychange", function () { if (!document.hidden) pull(); });

  // the market is settled after this script on a first visit: redraw when the theme flips the class
  var lastIntl = intl();
  if (window.MutationObserver) new MutationObserver(function () {
    var now = intl(); if (now === lastIntl) return; lastIntl = now; renderGrid(); render();
  }).observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });

  renderGrid();
  if (D.cart && D.cart.items) setServer(D.cart); else render();
  pull();
})();
